import React from "react";
import restorelungs from "../assets/articale/happy woman.png";
import arrowup from "../assets/arrowblue.png";

const MetabolicHealth = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-800 mb-6">
        {
          "Support Digestion & Metabolic Health the Natural Way"
        }
      </h2>
      <div className="relative w-full mb-6">
        <img
          src={restorelungs}
          alt="happy woman"
          className="w-full rounded-3xl border border-gray-100"
          draggable="false"
        />
      </div>
      <div className="space-y-4 text-[#303030]">
      
        <p>
        Slimetics offers a simple daily supplement featuring the powerful probiotic <span class="font-bold"> Akkermansia muciniphila, </span>  known for supporting gut health and metabolic function.
        </p>
      
        <h2 className="text-2xl font-bold text-[#303030] mb-6">
        {"Meet Akkermansia muciniphila – “The Guardian of the Gut”"} 
        </h2>
        <p> This probiotic has been shown in studies to help:</p>

        <div className="bg-[#e2f4f9] p-4"> 
          <div className="flex items-center gap-3 mb-4 last:mb-0"> 
            <div className="flex-shrink-0"> 
              <div className="flex-shrink-0"> 
                <img 
                  src={arrowup}  
                  alt="" 
                  className="w-10 h-10"  
                  draggable="false"  
                />
              </div> 
            </div> 
            <p className="text-gray-800 font-bold">  
              {" Promote a healthy metabolism at the cellular level "} 
            </p> 
          </div>  
          <div className="flex items-center gap-3 mb-4 last:mb-0">
            <div className="flex-shrink-0"> 
              <div className="flex-shrink-0"> 
                <img 
                  src={arrowup} 
                  alt="" 
                  className="w-10 h-10"
                  draggable="false"
                />
              </div>  
            </div>
            <p className="text-gray-800 font-bold">
              {"Support the gut lining and reduce discomfort "} 
            </p>
          </div>
          <div className="flex items-center gap-3 mb-4 last:mb-0"> 
            <div className="flex-shrink-0"> 
              <div className="flex-shrink-0"> 
                <img 
                  src={arrowup} 
                  alt="" 
                  className="w-10 h-10" 
                  draggable="false" 
                /> 
              </div> 
            </div> 
            <p className="text-gray-800 font-bold">  
              {"Help balance gut bacteria and reduce inflammation "}  
            </p>  
          </div>



           <div className="flex items-center gap-3 mb-4 last:mb-0"> 
            <div className="flex-shrink-0"> 
              <div className="flex-shrink-0"> 
                <img 
                  src={arrowup} 
                  alt="" 
                  className="w-10 h-10" 
                  draggable="false" 
                /> 
              </div> 
            </div> 
            <p className="text-gray-800 font-bold">  
              {" Encourage healthy appetite regulation "}  
            </p>  
          </div> 
        </div> 











        
        <div>
        <div>
            <p className="font-bold">How It Works</p>
          </div>
          <div>
            <p className="font-bold">{" Step 1: Rebalance Gut Health & Encourage Fat Burning"}</p>
          </div>
          <div>
            <p>
        
            People with healthy weight profiles tend to have higher levels of Akkermansia muciniphila. Slimetics supports the growth of this beneficial probiotic, helping restore your body’s natural balance.
            </p>
          </div>
        </div>
        <div>
          <div>
            <p className="font-bold">{"Step 2: Strengthen the Gut Barrier & Improve Digestion"}</p>
          </div>
          <div>
            <p>
            A healthy gut barrier may help reduce inflammation and support smoother digestion—helping your body absorb nutrients more efficiently.
            </p>
          </div>
        </div>
        <div>
          <div>
            <p className="font-bold">{"Step 3: Naturally Support Appetite & Cravings"}</p>
          </div>
          <div>
            <p>
            With your gut functioning more efficiently, cravings for processed food often decline—and your body can better manage energy and hunger cues.
            </p>
            <p>Slimetics is designed to support this three-step approach naturally and gently—without stimulants or extreme restrictions.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetabolicHealth;
